import { RequestState } from './utils/state-manager';

export type IndustryState = {
  industries: Array<Industry> | null;
  industriesState: RequestState;
};
type State = { industries: IndustryState };

export const industriesSelector = (state: State) => state.industries.industries;
export const industriesStateSelector = (state: State) => state.industries.industriesState;
